import React from "react";

export const GlobalNavProfile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GlobalNavProfile" */
      "./cms-components/nav/GlobalNavProfile"
    )
);
export const ProductComparison = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductComparison" */
      "./cms-components/calculators/ProductComparison"
    )
);
export const Careers = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Careers" */
      "./cms-components/careers/Careers"
    )
);
export const BannerComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BannerComponentContainer" */
      "./cms-components/banner/BannerComponentContainer"
    )
);
export const CheckEmailComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CheckEmailComponentContainer" */
      "./cms-components/check-email/CheckEmailComponentContainer"
    )
);
export const DemoComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DemoComponentContainer" */
      "./cms-components/demo/DemoComponentContainer"
    )
);

export const PriceFinderContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PriceFinderContainer" */
      "./cms-components/pricing-calculator/PriceFinderContainer"
    )
);
export const PricingExampleContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PricingExampleContainer" */
      "./cms-components/pricing-calculator/PricingExampleContainer"
    )
);
export const WacSiteRenameFormContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "WacSiteRenameFormContainer" */
      "./cms-components/site-rename/WacSiteRenameFormContainer"
    )
);
export const ProductTemplateSiteSelectorContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductTemplateSiteSelectorContainer" */
      "./cms-components/product/ProductTemplateSiteSelectorContainer"
    )
);
export const ProductTemplateSiteSelectorViewContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductTemplateSiteSelectorViewContainer" */
      "./cms-components/product/ProductTemplateSiteSelectorViewContainer"
    )
);
export const QrcodeComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "QrcodeComponentContainer" */
      "./cms-components/qrcode/QrcodeComponentContainer"
    )
);
export const ConfigurableQuizContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ConfigurableQuizContainer" */
      "./cms-components/configurable-quiz/ConfigurableQuizContainer"
    )
);
export const MiniQuizContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MiniQuiz" */
      "./cms-components/mini-quiz/MiniQuizContainer"
    )
);
export const WacSignUpLayoutContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "WacSignUpLayoutContainer" */
      "./sign-up-layout/WacSignUpLayoutContainer"
    )
);
export const GlobalNavDropdown = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GlobalNavDropdown" */
      "./cms-components/nav/GlobalNavDropdown"
    )
);
export const TemplateCardGenerator = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TemplateCardGenerator" */
      "./cms-components/showroom/TemplateCardGenerator"
    )
);
export const WacFreeBundlesContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "WacFreeBundlesContainer" */
      "./cms-components/wac-free-bundles/WacFreeBundlesContainer"
    )
);
export const EctlListComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EctlListComponentContainer" */
      "./cms-components/ectl-list/EctlListComponentContainer"
    )
);
export const SiteSelectionListComponentContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SiteSelectionListComponentContainer" */
      "./cms-components/site-selection-list/SiteSelectionListComponentContainer"
    )
);
export const WacConfirmationPageContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "WacConfirmationPageContainer" */
      "./cms-components/wac-confirmation-page/WacConfirmationPageContainer"
    )
);
export const EditionFeatureComparisonTableContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EditionFeatureComparisonTableContainer" */
      "./cms-components/edition-feature-comparison-table/EditionFeatureComparisonTableContainer"
    )
);
export const FeaturesHighlightContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeaturesHighlightContainer" */
      "./cms-components/features-highlight-wpl/FeaturesHighlightContainer"
    )
);
export const ProductHubInfoContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductHubInfoContainer" */
      "./cms-components/product-hub-info/ProductHubInfoContainer"
    )
);
export const DirectBuyConfirmationPageContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DirectBuyConfirmationPageContainer" */
      "./cms-components/direct-buy-confirmation-page/DirectBuyConfirmationPageContainer"
    )
);
export const DirectBuySiteSetupContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DirectBuySiteSetupContainer" */
      "./cms-components/direct-buy-site-setup/DirectBuySiteSetupContainer"
    )
);
export const JswInteractiveRoadmapContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "JswInteractiveRoadmapContainer" */
      "./cms-components/jsw-interactive-roadmap/JswInteractiveRoadmapContainer"
    )
);
export const HelloWorldModuleContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HelloWorldModuleContainer" */
      "./cms-components/helloWorldModule/HelloWorldModuleContainer"
    )
);
export const AnchorTagSignupEmailContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AnchorTagSignupEmailContainer" */
      "./cms-components/anchorTagSignupEmail/AnchorTagSignupEmailContainer"
    )
);
export const SignupModuleContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SignupModuleContainer" */
      "./cms-components/signupModule/SignupModuleContainer"
    )
);
export const SignupProvisioningModuleContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SignupProvisioningModuleContainer" */
      "./cms-components/signupProvisioningModule/SignupProvisioningModuleContainer"
    )
);

export const AtlassianIntelligencePrimaryContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AtlassianIntelligencePrimaryContainer" */
      "./cms-components/atlassianIntelligencePrimary/AtlassianIntelligencePrimaryContainer"
    )
);
export const ExtendedTrialUpgradeModuleContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExtendedTrialUpgradeModuleContainer" */
      "./cms-components/extendedTrialUpgradeModule/ExtendedTrialUpgradeModuleContainer"
    )
);
export const MultiProductCalculatorContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MultiProductCalculatorContainer" */
      "./cms-components/multiProductCalculator/MultiProductCalculatorContainer"
    )
);

export const JswInteractiveBoardContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "JswInteractiveBoardContainer" */
      "./cms-components/jswInteractiveBoard/JswInteractiveBoardContainer"
    )
);

export const CartBtn = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CartBtn" */
      "./cms-components/cart-btn/CartBtn"
    )
);

export const AdminHubOrgSelectorDeeplinkerContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "JswInteractiveBoardContainer" */
      "./cms-components/admin-hub-org-selector-deeplinker/AdminHubOrgSelectorDeeplinkerContainer"
    )
);

export const ReturnToProductModal = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ReturnToProductModal" */
      "./cms-components/return-to-product-modal/ReturnToProductModal"
    )
);

export const SigninPromptComponent = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SigninPromptComponent" */
      "./cms-components/signin-prompt-component/SigninPromptComponent"
    )
);